export default __webpack_public_path__ + "static/media/zonemap.d28ae159.png";